// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"715a4d4d","503":"a2364f69"}[chunkId] + ".css";
};